import styled from "styled-components";

export const Button = styled.button`
  margin: 10px;
  padding: 2px;
  width: 8vw;
  height: 2.2vw;
  background-color: #49F4FF;
  box-shadow: 2px 2px 4px #FF74A2;
  border-radius: 4px;
  color: #141D2C;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  border: none;
  cursor: pointer;
  transition:300ms;

  &:hover {
    margin: 10px;
    padding: 2px;
    width: 8vw;
    height: 2.2vw;
    background-color: #E756FF;
    box-shadow: 2px 2px 4px #49F4FF;
    border-radius: 4px;
    color: #49F4FF;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    border: none;
    text-decoration:underline;
  }
`;
